import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    request: {},
    data: {
        meeting: {},
        participant: {},
    },
    meetingState: {
        isMeetingCompleted: false,
        isMeetingCancelled: false,
        isCurrentUserParticipant: false,
        isMeetingDeclined: false,
        meetingConditionType: null,
    },
};
export const schedulingSlice = createSlice({
    name: 'scheduling',
    initialState,
    reducers: {
        fetchMeeting(_state, _action) {
            // state.request = action.payload;
        },
        storeMeeting(state, action) {
            const { meeting, participant, isMeetingCancelled, isMeetingCompleted, isMeetingDeclined, meetingConditionType } = action.payload;
            state.data = {
                meeting,
                participant,
            };
            state.meetingState = {
                isMeetingCancelled,
                isMeetingCompleted,
                isMeetingDeclined,
                isCurrentUserParticipant: !!participant,
                meetingConditionType,
            };
        },
        participantMeetingStatusRequest(_state, _action) { },
        updateParticipantStatus(state, action) {
            if (state.data.participant) {
                state.data.participant = {
                    ...state.data.participant,
                    participation_status: action.payload.status,
                };
            }
        },
    },
});
export const { fetchMeeting, storeMeeting, participantMeetingStatusRequest, updateParticipantStatus } = schedulingSlice.actions;
export default schedulingSlice.reducer;
